import { ChevronDown } from 'lucide-react';
import { cn } from '@repo/utils';
import { FormField } from './FormField';

interface SelectOption {
  value: string;
  label: string;
}

interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: SelectOption[];
  required?: boolean;
  error?: string;
  hint?: string;
}

export function FormSelect({
  label,
  options,
  required,
  error,
  hint,
  className,
  id,
  ...props
}: FormSelectProps) {
  // allow-raw-sql: "select-" is an HTML element id prefix, not SQL — heuristic false positive
  const fieldId = id ?? `select-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <FormField label={label} required={required} error={error} hint={hint} htmlFor={fieldId}>
      <div className="relative">
        <select
          id={fieldId}
          {...props}
          className={cn(
            'w-full h-9 pl-3 pr-10 bg-surface-3 border border-border rounded-[6px] text-sm text-text-primary',
            'focus:outline-none focus:border-accent-500 focus:ring-1 focus:ring-accent-500',
            'disabled:opacity-50 disabled:cursor-not-allowed appearance-none',
            error && 'border-danger-500 focus:border-danger-500 focus:ring-danger-500',
            className,
          )}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-text-muted">
          <ChevronDown className="w-4 h-4" />
        </div>
      </div>
    </FormField>
  );
}
